module.exports = __webpack_public_path__ + "img/title.778cc3d3.png";